var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAngleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5 18C25.5 17.6019 25.3589 17.24 25.0766 16.9505L15.9036 7.90272C15.3391 7.35986 14.4571 7.35985 13.8926 7.93891C13.3634 8.51796 13.3634 9.42276 13.9279 10.0018L22.0425 18L13.9279 25.9982C13.3634 26.5411 13.3634 27.482 13.8926 28.0611C14.4218 28.6401 15.3391 28.6401 15.9036 28.0972L25.0766 19.0495C25.3589 18.76 25.5 18.3981 25.5 18Z",
    fill: "#2C3D50"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleArrowRight);
export default __webpack_public_path__ + "static/media/angle-arrow-right.ec2b2b02db2ea20d1c0d9ef915a1cab0.svg";
export { ForwardRef as ReactComponent };